import React from 'react';

export const NewsPage = () => {
  React.useEffect(() => {
    window.location.href = 'https://clinicten.jp/news/';
  }, []);
  return <>お知らせページにリダイレクトしています...</>;
};
